import { setToken, getToken } from '@/utils/helper'
import { default as $api } from '@/api'

export default {
  state: {
    token: getToken(),
    userInfo: {}
  },
  getters: {
    isLogin: state => {
      return !!state.token.length
    }
  },
  mutations: {
    setUserToken(state, token) {
      setToken(token)
      state.token = token
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    login({ commit }, { endpoint_type, mobile, code }) {
      mobile = mobile.trim()
      return new Promise((resolve, reject) => {
        $api.user
          .login({
            endpoint_type,
            mobile,
            code
          })
          .then(response => {
            const data = response.data

            if (data.code === 0) {
              commit('setUserToken', data.data.token)
              localStorage.setItem('token', data.data.token)
            }

            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    logOut({ commit }) {
      commit('setUserToken', '')
    }
  }
}
